import React, { useCallback, useEffect, useMemo } from 'react';

import { downloadExcel, downloadSettingExcel } from "src/utils/blob/blobUtil";

import { SysCodeDto } from 'src/dtos/code/sysCodeDto';

import { defaultSAL2020_R01Filter, SAL2020_R01Filter, useSAL2020_R01Store } from 'src/containers/mes/SAL/SAL2020_R01/Store_SAL2020_R01';
import useFetchActionbarAuth from 'src/hooks/useFetchActionbarAuth';
import { Tab } from 'src/store/useUiuxStore';
import { useLoadingSpinnerStore } from 'src/store/util/loadingSpinnerUtil';
import { showError, showSuccess, ShowSuccessFetch, showWarning } from 'src/utils/toast/toastUtil';

import { deleteSAL2020_R01, downloadExcel_SAL2020_R01, getSAL2020_R01AllCount, getSAL2020_R01DetailList, getSAL2020_R01List, getSAL2020_R01One, getPdfBlob_SAL2020_R01, patchSAL2020_R01, postSAL2020_R01 } from "./Api_SAL2020_R01";
import { defaultSAL2020_R01DetailDto, defaultSAL2020_R01HeaderDto, SAL2020_R01DetailDto, SAL2020_R01Dto, SAL2020_R01HeaderDto } from './Dto_SAL2020_R01';
import { filterDeletedItems } from 'src/utils/calculation/calculationUtils';
import { AgGridReact } from 'ag-grid-react';
import { fetchDataSetHandler, fetchFilterConfig, gridRefSelectedRowHandler } from 'src/utils/grid/GridHandlerContent';
import { CompanyDto } from 'src/dtos/company/companyDto';
import { useCommonCodeStore } from 'src/store/useCommonCodeStore';
import { validateString } from 'src/utils/string/stringUtil';
import { validateCustomCd, validateEmployeeCd } from 'src/utils/grid/GridValidateContent';
import { useCommonCodeValidate } from 'src/utils/commonCode/CommonCodeValidateContext';
import {
	buildCommonCodeRequirements,
	SAL2020_R01_HEADER_ROW_VALIDATE,
} from 'src/utils/commonCode/commonCodeRequirementConfig';
import { useQzPrint } from 'src/hooks/useQzPrint';
import qz from 'qz-tray';

interface Props {
	gridRef: React.RefObject<AgGridReact<SAL2020_R01HeaderDto> | null>;
	detailGridRef: React.RefObject<AgGridReact<SAL2020_R01DetailDto> | null>;

	tabList: Tab[] | undefined;
	setMessage: (message: string) => void;

	containerRef: React.RefObject<HTMLDivElement | null>;
	isResizing: React.MutableRefObject<boolean>;
	
}



export const Content_SAL2020_R01 = (props: Props) => {

	const {
		gridRef, detailGridRef,
		tabList, setMessage,
		containerRef,
		isResizing,
	} = props;

	const { moneyCdList, vatTypeList, compCdList, customCdList, employeeCdList, itemCdMap } = useCommonCodeStore();

	
	const {
		SAL2020_R01Filter, setSAL2020_R01Filter,
		SAL2020_R01PastFilter, setSAL2020_R01PastFilter,
		SAL2020_R01List, setSAL2020_R01List,
		editSAL2020_R01, setEditSAL2020_R01,
		selectedSAL2020_R01, setSelectedSAL2020_R01, 
		deletedSAL2020_R01DetailList, setDeletedSAL2020_R01DetailList, addDeletedSAL2020_R01DetailList, removeDeletedSAL2020_R01DetailList, 
		selectedSAL2020_R01DetailList, setSelectedSAL2020_R01DetailList, addSelectedSAL2020_R01DetailList, removeSelectedSAL2020_R01DetailList,
		SAL2020_R01DetailList, setSAL2020_R01DetailList, insertSAL2020_R01DetailList,
		originalSAL2020_R01DetailList, setOriginalSAL2020_R01DetailList,
		allCount, setAllCount,
		detailFetchTrigger, setDetailFetchTrigger,
		initData,
		setScrollTop, setDetailScrollTop,
	} = useSAL2020_R01Store();
	const { setLoadingSpinner } = useLoadingSpinnerStore();
	const { validateCommonCodeLists } = useCommonCodeValidate();
	const { printPdfFromBlob } = useQzPrint();

	useFetchActionbarAuth("SAL2020_R01");

	const handlePrintClick = useCallback(async () => {
		if (!selectedSAL2020_R01?.salBillNo) {
			showWarning("출력할 매출번호를 선택하세요.");
			return;
		}
		setLoadingSpinner(true);
		try {
			const blob = await getPdfBlob_SAL2020_R01(selectedSAL2020_R01.salBillNo);
			if (qz.websocket.isActive()) {
				const ok = await printPdfFromBlob(blob, "report1");
				if (ok) {
					showSuccess("PDF 출력이 완료되었습니다.");
				} else {
					const fileURL = URL.createObjectURL(blob);
					const win = window.open(fileURL, "_blank");
					if (win) win.addEventListener("load", () => win.print());
					showWarning("QZ로 출력할 수 없어 브라우저 인쇄 창을 띄웁니다.");
				}
			} else {
				const fileURL = URL.createObjectURL(blob);
				window.open(fileURL, "_blank");
				showSuccess("PDF를 새 탭에서 열었습니다.");
			}
		} catch (error) {
			console.error("Print error:", error);
			showError("PDF 출력 중 오류가 발생했습니다.");
		} finally {
			setLoadingSpinner(false);
		}
	}, [selectedSAL2020_R01, printPdfFromBlob, setLoadingSpinner]);
	

	const handleExcelClick = useCallback(async () => {
		if (!selectedSAL2020_R01) {
			showWarning("선택된 매출내역이 없습니다.");
			return;
		}
		setLoadingSpinner(true);

		const response = await downloadExcel_SAL2020_R01('', selectedSAL2020_R01.salBillNo, SAL2020_R01List.length ?? 0);

		downloadSettingExcel({ responseData: response.data.data, fileName: '매출전표 등록-excel.xlsx' });

		setLoadingSpinner(false);
	}, [selectedSAL2020_R01])

	const getParams = (filter: SAL2020_R01Filter) => {
		const params: Partial<SAL2020_R01Filter> = {
			compCd: filter.compCd || undefined,
			dateRange: filter.dateRange || undefined,
			customCd: filter.customCd || undefined,
		};
		return params;
	}

	const renewalAllCount = useCallback(async () => {
		const response = await getSAL2020_R01AllCount(getParams(SAL2020_R01Filter));
		setAllCount(response.data.data);
		return response.data.data;
	}, [SAL2020_R01Filter, setAllCount]);

	const fetchData = useCallback(async () => {
		setScrollTop(null);
		setDetailScrollTop(null);
		setLoadingSpinner(true);		

		const responseData = (await getSAL2020_R01List(
			'',
			getParams(SAL2020_R01Filter),
			SAL2020_R01List.length ?? 0
		));


		let newList = [...responseData.data.data ] as SAL2020_R01HeaderDto[];
		setSAL2020_R01List(newList);

		const processAllCount = await renewalAllCount();
		if (newList && newList.length > 0) {
			gridRefSelectedRowHandler(
				gridRef,
				setSelectedSAL2020_R01,
				() => true,// () => !responseData.find(value => value.salBillNo === selectedSAL2020_R01?.salBillNo)
			);
			setSAL2020_R01PastFilter(SAL2020_R01Filter);
			ShowSuccessFetch(setMessage, `조회가 완료되었습니다. (총 ${newList.length}/${processAllCount}건)`);
			setTimeout(() => setMessage(""), 5000);
		}else {
			showWarning('데이터가 없습니다.');
			handleCreateClick();
		}
		setLoadingSpinner(false);
		return responseData;
	}, [SAL2020_R01Filter, SAL2020_R01List, setSAL2020_R01List, setSAL2020_R01PastFilter, setSelectedSAL2020_R01, selectedSAL2020_R01, setScrollTop, setDetailScrollTop]);

	const defaultSAL2020_R01HeaderRow = useCallback(() => {
		const commonResult = validateCommonCodeLists(
			buildCommonCodeRequirements(SAL2020_R01_HEADER_ROW_VALIDATE, {
				compCdList,
				moneyCdList,
				vatTypeList,
			}),
		);
		if (!commonResult.valid) {
			return { ...defaultSAL2020_R01HeaderDto };
		}

		return {
			...defaultSAL2020_R01HeaderDto,
			compCd: compCdList[0].compCd,
			vatType: vatTypeList[0].minorCd,
			moneyCd: moneyCdList[0].minorCd,
		};
	}, [defaultSAL2020_R01HeaderDto, compCdList, vatTypeList, moneyCdList, validateCommonCodeLists]);

	const defaultSAL2020_R01DetailRow = useCallback(() => {
		return {
			...defaultSAL2020_R01DetailDto,
			inserted: true,
		}
	}, [defaultSAL2020_R01DetailDto]);

	const fetchOne = useCallback(async () => {
		if (!selectedSAL2020_R01) return;
		setLoadingSpinner(true);
		try {
			const response = await getSAL2020_R01One(selectedSAL2020_R01.salBillNo!);
			setEditSAL2020_R01(response.data.data as SAL2020_R01HeaderDto);
		} catch (error) {
			console.error("조회 중 오류 발생:", error);
			showError("조회 중 오류가 발생했습니다.");
		}
		setLoadingSpinner(false);
	}, [selectedSAL2020_R01])

	const fetchDetailList = useCallback(async (salBillNo: string) => {
		if (!detailFetchTrigger) return;
		setDetailScrollTop(null);

		(detailGridRef.current as any)?.clearRange?.();

		const responseData = (await getSAL2020_R01DetailList(salBillNo)).data.data;
		if(responseData && responseData.length > 0){
			setSAL2020_R01DetailList(responseData.map((value, idx) => ({
				...value,
				valueIndex: value.valueIndex ?? idx + 1,
				orderIndex: value.orderIndex ?? idx + 1,
				orderIndexSeq: value.orderIndexSeq ?? 0,
				itemCost: value.salesPrice,
				salBillNo: value.salBillNo,
				itemNo: value.itemNo,
			})));
			setOriginalSAL2020_R01DetailList(responseData);
			setMessage(`${selectedSAL2020_R01?.customNm}의 상세내역 ${responseData.length}건을 조회하였습니다.`);
			setTimeout(() => setMessage(""), 5000);
		}else{
			showError('상세내역이 없습니다.');
			setSAL2020_R01DetailList([]);
			insertSAL2020_R01DetailList([{ ...defaultSAL2020_R01DetailRow() }])
		}
		setDetailFetchTrigger(false);
	}, [
		detailFetchTrigger,
		setDetailScrollTop,
		detailGridRef,
		setSAL2020_R01DetailList,
		setOriginalSAL2020_R01DetailList,
		selectedSAL2020_R01?.customNm,
		setMessage,
		insertSAL2020_R01DetailList,
		defaultSAL2020_R01DetailRow,
		setDetailFetchTrigger,
	])
	
	const initContainerData = useCallback(() => {
		initData();
		removeDeletedSAL2020_R01DetailList();
		removeSelectedSAL2020_R01DetailList();
		setEditSAL2020_R01({ ...defaultSAL2020_R01HeaderRow() });
	}, [defaultSAL2020_R01HeaderRow, defaultSAL2020_R01DetailRow])

	const handleDeleteClick = useCallback(() => {

		if (deletedSAL2020_R01DetailList.length > 0) {
			// 삭제 표시된 행이 있으면 전체 복구
			removeDeletedSAL2020_R01DetailList(deletedSAL2020_R01DetailList);
			removeSelectedSAL2020_R01DetailList();
			setSAL2020_R01DetailList([...SAL2020_R01DetailList]);
		} else if (selectedSAL2020_R01DetailList.length > 0) {
			addDeletedSAL2020_R01DetailList(selectedSAL2020_R01DetailList);
			removeSelectedSAL2020_R01DetailList(selectedSAL2020_R01DetailList);
		}
	}, [selectedSAL2020_R01DetailList, 
		deletedSAL2020_R01DetailList,
		addDeletedSAL2020_R01DetailList,
		removeDeletedSAL2020_R01DetailList,
		removeSelectedSAL2020_R01DetailList,
		setSAL2020_R01DetailList,
		SAL2020_R01DetailList]);
	
	const handleCreateClick = () => {
		// 등록 모드로 전환: 선택된 행 해제, 편집 데이터 초기화, 상세 목록 초기화
		setSelectedSAL2020_R01(undefined);
		setEditSAL2020_R01({ ...defaultSAL2020_R01HeaderRow(), salBillNo: '' });
		setSAL2020_R01DetailList([{...defaultSAL2020_R01DetailRow()}]);
		// 상세 관련 상태들도 초기화
		setDeletedSAL2020_R01DetailList([]);
		setSelectedSAL2020_R01DetailList([]);
		setOriginalSAL2020_R01DetailList([]);
		setDetailScrollTop(null);
	}

	const validateInsertData = useCallback((header: SAL2020_R01HeaderDto, detailList: SAL2020_R01DetailDto[]) => {
		
		if (!validateString(header.compCd)) {
			showWarning('사업장을 선택해주세요.'); return false;
		}
		if (!validateString(header.customCd)) {
			showWarning('거래처를 입력해주세요.'); return false;
		}
		if (!validateCustomCd(header.customCd, customCdList)) {
			showWarning('거래처가 존재하지 않습니다.(입력칸을 더블클릭하거나 엔터키로 세부사항을 열어서 지정해주세요)'); return false;
		}
		if (header.deliveryDt === undefined) {
			showWarning('출고일자를 입력해주세요.'); return false;
		}
		if (!header.salesDt) {
			showWarning('매출일자를 입력해주세요.'); return false;
		}
		if (!validateString(header.empNo)) {
			showWarning('담당자를 선택해주세요.'); return false;
		}
		if (!validateEmployeeCd(header.empNo, employeeCdList)) {
			showWarning('담당자가 존재하지 않습니다.(입력칸을 더블클릭하거나 엔터키로 세부사항을 열어서 지정해주세요)'); return false;
		}
		if (!validateString(header.moneyCd)) {
			showWarning('화폐유형을 선택해주세요.'); return false;
		}
		if (!validateString(header.vatType)) {
			showWarning('부가세 유형을 선택해주세요.'); return false;
		}
		if (!validateString(header.moneyCd)) {
			showWarning('통화를 선택해주세요.'); return false;
		}

		// 삭제되지 않은 상세 행들만 필터링하여 검증
		const activeDetailList = filterDeletedItems(detailList, deletedSAL2020_R01DetailList);



		// 상세 데이터 검증 (삭제되지 않은 행들만)
		for (const detail of activeDetailList) {
			if (!validateString(detail.itemCd)) {
				showWarning('품목코드를 입력해주세요.'); return false;
			}
			if (detail.salesQty === 0) {
				showWarning('수량을 입력해주세요.'); return false;
			}
			if (detail.salesPrice === 0) {
				showWarning('단가를 입력해주세요.'); return false;
			}
			
			// 중복 품목코드 검증
			const otherDetailList = activeDetailList.filter((_, index) => 
				index !== activeDetailList.findIndex(d => d.valueIndex === detail.valueIndex)
			);
			if (otherDetailList.some(otherDetail => otherDetail.itemCd === detail.itemCd)) {
				showWarning(`중복된 품목코드가 있습니다.\n품목코드: ${detail.itemCd}`);
				return false;
			}
			// 품목코드 존재 검증
			if (!itemCdMap.has(detail.itemCd)) {
				showWarning('품목코드가 해당 MES의 품목정보에 존재하지 않습니다.\n품목코드: ' + detail.itemCd); return false;
			}
		}

		return true;
	}, [itemCdMap])
	
	const handleSaveClick = useCallback(async () => {

		// 데이터 검증 (삭제되지 않은 행들만)
		if (!validateInsertData(editSAL2020_R01!, SAL2020_R01DetailList)) {
			return;
		}
		
		// 삭제된 상세 행들을 필터링
		const activeDetailList = filterDeletedItems(SAL2020_R01DetailList, deletedSAL2020_R01DetailList);
		
		let processName = '';
		let newDetailList: SAL2020_R01DetailDto[] = [];
		let newHeaderList: SAL2020_R01HeaderDto[] = [];
		let responseData: SAL2020_R01Dto = {
			salesBillHeaderDto: editSAL2020_R01!,
			salesBillDetailDtoList: activeDetailList
		};

		if (selectedSAL2020_R01) {
			newDetailList = activeDetailList;

			if (newDetailList.length === 0) {
				processName = 'delete';
				const deleteResponse = await deleteSAL2020_R01(selectedSAL2020_R01.salBillNo);

				newHeaderList = SAL2020_R01List.filter(value => value.salBillNo !== selectedSAL2020_R01.salBillNo);

				if (deleteResponse && deleteResponse.data) {
					if (deleteResponse.data.successFlag) {
						showSuccess('매출 삭제가 성공하였습니다.');
						setMessage('매출 삭제가 성공하였습니다.');
					}else return;
				}
			} else {
				processName = 'patch';
				const patchResponse = await patchSAL2020_R01({
					salesBillHeaderDto: editSAL2020_R01!,
					salesBillDetailDtoList: newDetailList
				});

				responseData = patchResponse.data.data[0];
				newHeaderList = SAL2020_R01List.map(value => {
					if (value.salBillNo === responseData.salesBillHeaderDto.salBillNo) {
						return responseData.salesBillHeaderDto;
					}
					return value;
				});
				
				if (patchResponse?.data?.data?.[0] && patchResponse.data.successFlag) {

					showSuccess('매출 수정에 성공하였습니다.');
					setMessage('매출 수정에 성공하였습니다.');
				}else {
					// 서버 응답이 예상과 다를 경우의 에러 처리
					showWarning('매출 등록 후 서버로부터 올바른 데이터를 받지 못했습니다.');
					return;
				}
			}
		} else {
			processName = 'post';
			const postResponse = await postSAL2020_R01({
				salesBillHeaderDto: editSAL2020_R01!,
				salesBillDetailDtoList: SAL2020_R01DetailList
			});
			responseData = postResponse.data.data[0];

			newHeaderList = [
				...SAL2020_R01List,
				responseData.salesBillHeaderDto, // responseData에서 헤더를 가져옵니다.
			] as SAL2020_R01HeaderDto[];
			
			if (postResponse?.data?.data?.[0] && postResponse.data.successFlag) {
				showSuccess('매출 등록에 성공하였습니다.');
				setMessage('매출 등록에 성공하였습니다.');
			}else {
				// 서버 응답이 예상과 다를 경우의 에러 처리
				showWarning('매출 등록 후 서버로부터 올바른 데이터를 받지 못했습니다.');
				return;
			}
		}


		if (processName === 'delete') {
			setSAL2020_R01List(newHeaderList);
			setSelectedSAL2020_R01(undefined);
			setSAL2020_R01DetailList([]);
			handleCreateClick();
		}else if (processName === 'patch') {
			// 수정의 경우 선택된 행을 업데이트
			setSAL2020_R01List(newHeaderList);
			setSAL2020_R01DetailList(responseData.salesBillDetailDtoList);
			setSelectedSAL2020_R01(responseData.salesBillHeaderDto);
			setOriginalSAL2020_R01DetailList(responseData.salesBillDetailDtoList);
		}else if (processName === 'post') {
			// SAL1010과 동일한 패턴: 등록 후에도 selectedSAL2020_R01을 설정하여 조회 모드로 전환
			setSAL2020_R01List(newHeaderList);
			setSAL2020_R01DetailList(responseData.salesBillDetailDtoList);
			setSelectedSAL2020_R01(responseData.salesBillHeaderDto);
			setOriginalSAL2020_R01DetailList(responseData.salesBillDetailDtoList);
		}

		// setSelectedSAL2020_R01(undefined);
		setDeletedSAL2020_R01DetailList([]);
		setSelectedSAL2020_R01DetailList([]); // 저장 후 상세행 선택 상태 초기화
		setTimeout(() => {
			setMessage('');
		}, 5000)
	
	}, [
		editSAL2020_R01, 
		selectedSAL2020_R01, 
		SAL2020_R01DetailList, 
		deletedSAL2020_R01DetailList, 
		SAL2020_R01List, setSAL2020_R01List
	])

	useEffect(() => {
		if (selectedSAL2020_R01) {
			fetchOne();
			fetchDetailList(selectedSAL2020_R01.salBillNo!)
		}
	}, [selectedSAL2020_R01, fetchOne, fetchDetailList])

	// 상세 데이터가 없을 때 기본 행 추가
	useEffect(() => {
		if (selectedSAL2020_R01 && SAL2020_R01DetailList.length === 0) {
			insertSAL2020_R01DetailList([{ ...defaultSAL2020_R01DetailRow() }])
		}
	}, [selectedSAL2020_R01, SAL2020_R01DetailList])
	
	return {
		handlePrintClick,
		handleExcelClick,
		fetchData,
		defaultSAL2020_R01HeaderRow,
		defaultSAL2020_R01DetailRow,
		initContainerData,
		handleDeleteClick,
		handleCreateClick,
		handleSaveClick,
	};
}
